<app-header-page *ngIf="visibleHeader">
    <h1>{{ 'HEADERS.MENU' | translate }}</h1>
</app-header-page>

<div>
    <button (click)="previousDefaultMenu()"
            class="btn btn-danger mb-2"
    >
        <i class="bi bi-trash me-1"></i>
        <span>{{ 'BUTTON_TEXT.RESET_SETTINGS' | translate }}</span>
    </button>
</div>

<div class="row default-container">
    <div class="col-4 left-default-container">
        <div (click)="openCreateMenuItemModal(addMenuItem)"
             class="mb-2 menu-global-item"
        >
            <i class="bi bi-plus xxxlg-icon"></i>
            <h2 class="mb-0">{{ 'BUTTON_TEXT.CREATE_MENU' | translate }}</h2>
        </div>
        <div (cdkDropListDropped)="updateGlobalItemAfterDrag($event)"
             *ngIf="currentMenu.length; else emptyArray"
             cdkDropList
             class="global-drag-container"
        >
            <div *ngFor="let item of currentMenu"
                 [cdkDragBoundary]="'.global-drag-container'"
                 [cdkDragData]="item"
                 [cdkDragStartDelay]="100"
                 cdkDrag
                 class="mb-2">
                <div (click)="openGlobalMenuItem(item)"
                     class="menu-global-item">
                    <i class="{{item.icon}} ms-1 me-2 xxxlg-icon"></i>
                    <h2 class="w-100 mb-0">
                        {{ !item.menu_key ? item.title : 'MAIN_MENU.MENU_ITEMS.' + item.menu_key | translate }}
                        <i (click)="openGlobalMenuModal(editGlobItemModal, item, $event)"
                           class="bi bi-pen pointer ms-1"
                        ></i>
                    </h2>
                    <i class="bi {{item.open ? 'bi-caret-down' : 'bi-caret-right'}} me-2 xxlg-icon"></i>
                    <i (click)="deleteMenuItem(item, $event)" class="bi bi-trash me-2 text-danger xlg-icon"></i>
                </div>

                <div (cdkDropListDropped)="updateSubItemAfterDrag($event)"
                     *ngIf="item.open"
                     cdkDropList
                     class="drag-container">
                    <div *ngFor="let subItem of item.children"
                         [cdkDragBoundary]="'.drag-container'"
                         [cdkDragData]="subItem"
                         [cdkDragStartDelay]="100"
                         cdkDrag
                         class="global-submenu-item">
                        <i class="{{memberService.subMenuIcons[subItem.submenu_key]}} ms-2 me-1 xlg-icon"></i>
                        <span class="w-100">
                        {{ 'MAIN_MENU.SUBMENU_ITEMS.' + subItem.submenu_key | translate }}
                            <br>
                            {{ 'MODALS.TEXT.' + subItem.sub_acc_type | translate }}
                    </span>
                        <i (click)="openModal(addMenuSubItem, subItem)" class="bi bi-gear me-1 pointer"></i>
                        <i (click)="deleteSubMenuItem(subItem)" class="bi bi-trash me-2 text-danger pointer"></i>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div *ngIf="showSubItems && selectedGlobalMenuItem"
         class="col-4 right-default-container"
    >
        <ng-container *ngTemplateOutlet="menuBuilder"></ng-container>
    </div>
</div>
<div *ngIf="isMenuEdit" class="fixed-button">
    <div class="btn-group btn-block w-100">
        <button (click)="saveMenu()"
                class="btn btn-success"
                data-action="saveRoadmapButton"
        >
            {{ 'BUTTON_TEXT.SAVE' | translate }}
        </button>
        <button (click)="cancelSaveMenu()"
                class="btn btn-primary"
                data-action="clearRoadmapChangesButton"
        >
            {{ 'BUTTON_TEXT.REVERT' | translate }}
        </button>
    </div>
</div>

<ng-template #menuBuilder>
    <div *ngFor="let subItem of allSubItems"
         class="global-submenu-item">
        <i (click)="openModal(addMenuSubItem, subItem)"
           class="bi bi-arrow-left ms-2 me-1 pointer"></i>
        <i class="{{memberService.subMenuIcons[subItem.submenu_key]}} ms-1 me-1 xlg-icon"></i>
        <span class="w-100">
            {{ 'MAIN_MENU.SUBMENU_ITEMS.' + subItem.submenu_key | translate }}
        </span>
    </div>
</ng-template>

<ng-template #addMenuSubItem let-modal>
    <app-button-modal-close [modalSize]="'sm'" [modal]="modal"></app-button-modal-close>
    <div class="modal-body">
        <h2>{{ 'MODALS.HEADERS.MENU_ACCESS_LEVEL' | translate }}</h2>
        <div class="btn-group-vertical w-100 mt-2">
            <button (click)="addSubItem('ALL', modal)"
                    class="btn btn-success"
            >
                {{ 'MODALS.TEXT.ALL' | translate }}
            </button>
            <button (click)="addSubItem('ONLY_ADMIN', modal)"
                    class="btn btn-success"
            >
                {{ 'MODALS.TEXT.ONLY_ADMIN' | translate }}
            </button>
            <button (click)="addSubItem('INNER', modal)"
                    class="btn btn-success"
            >
                {{ 'MODALS.TEXT.INNER' | translate }}
            </button>
            <button (click)="addSubItem('BLOCKED', modal)"
                    class="btn btn-success"
            >
                {{ 'MODALS.TEXT.BLOCKED' | translate }}
            </button>
        </div>
    </div>
</ng-template>

<ng-template #addMenuItem let-modal>
    <app-button-modal-close [modalSize]="'lg'" [modal]="modal"></app-button-modal-close>
    <div class="modal-body">
        <h2>{{ 'MODALS.HEADERS.CREATE_MENU' | translate }}</h2>
        <h2>{{ 'MODALS.FIELDS.TITLE' | translate }}</h2>
        <input #globalMenuName class="form-control" type="text">

        <h2>{{ 'MODALS.FIELDS.ICON' | translate }}</h2>
        <i (click)="isShowIcons = !isShowIcons"
           *ngIf="!icons.selected"
           data-action="openIcons"
           style="cursor: pointer; width: 200px;"
        >
            {{ 'MODALS.FIELDS.SELECT.ICON_NOT_SELECTED' | translate }}
        </i>
        <i (click)="isShowIcons = !isShowIcons"
           *ngIf="icons.selected"
           class="{{icons.selected}}"
           data-action="openIcons"
           style="font-size: 3em; cursor: pointer; width: 50px; height: 50px; margin-bottom: 15px;"
        ></i>

        <div *ngIf="isShowIcons" class="iconsTable table2">
            <i (click)="icons.selected = icon; isShowIcons = false;"
               *ngFor="let icon of icons.all"
               [attr.data-icon]="icon"
               class="{{icon}}"
               data-action="setIcon"
               style="margin: 5px; cursor: pointer; font-size: 2em;"
            ></i>
        </div>

        <div class="row w-100 mt-3">
            <div class="col-6">
                <div *ngIf="newGlobalMenuSubItems.length; else emptyArray">
                    <div *ngFor="let subItem of newGlobalMenuSubItems"
                         class="global-submenu-item">
                        <i class="{{memberService.subMenuIcons[subItem.submenu_key]}} ms-2 me-1 xlg-icon"></i>
                        <span class="w-100">
                            {{ 'MAIN_MENU.SUBMENU_ITEMS.' + subItem.submenu_key | translate }}
                            <br>
                            {{ 'MODALS.TEXT.' + subItem.sub_acc_type | translate }}
                    </span>
                        <i (click)="openModal(addMenuSubItem, subItem)" class="bi bi-gear me-1 pointer"></i>
                        <i (click)="deleteSubMenuItem(subItem)" class="bi bi-trash me-2 text-danger pointer"></i>
                    </div>
                </div>
            </div>
            <div class="col-6">
                <ng-container *ngTemplateOutlet="menuBuilder"></ng-container>
            </div>
        </div>
        <button (click)="createGlobalMenuItem(globalMenuName.value, modal)" class="btn btn-success mt-1">
            {{ 'MODALS.BUTTONS.ADD' | translate }}
        </button>
    </div>
</ng-template>


<ng-template #editGlobItemModal let-modal>
    <app-button-modal-close [modal]="modal"></app-button-modal-close>
    <div class="modal-body">
        <h2>{{ 'MODALS.HEADERS.CHANGE_MENU' | translate }}</h2>
        <h2>{{ 'MODALS.FIELDS.TITLE' | translate }}</h2>
        <input #mewItemName
               (change)="selectedGlobalMenuItem.title = mewItemName.value; isMenuEdit = true"
               [value]="!selectedGlobalMenuItem.menu_key ? selectedGlobalMenuItem.title : 'MAIN_MENU.MENU_ITEMS.' + selectedGlobalMenuItem.menu_key | translate "
               class="form-control"
               type="text"
        >

        <div>
            <h2>{{ 'MODALS.FIELDS.ICON' | translate }}</h2>
            <i (click)="isShowIcons = !isShowIcons"
               [class]="selectedGlobalMenuItem.icon"
               data-action="openIcons"
               style="font-size: 3em; cursor: pointer; width: 50px; height: 50px; margin-bottom: 15px;"
            ></i>

            <div *ngIf="isShowIcons" class="iconsTable table2">
                <i (click)="selectedGlobalMenuItem.icon = icon; isShowIcons = false; isMenuEdit = true"
                   *ngFor="let icon of icons.all"
                   [attr.data-icon]="icon"
                   [class]="icon"
                   data-action="setIcon"
                   style="margin: 5px; cursor: pointer; font-size: 2em;"
                ></i>
            </div>
        </div>

        <button (click)="modal.close()" class="btn btn-success mt-1">
            {{ 'MODALS.BUTTONS.SAVE' | translate }}
        </button>
    </div>
</ng-template>

<ng-template #emptyArray>
    <i>{{ 'EMPTY_LISTS.EMPTY' | translate }}</i>
</ng-template>
